import { makeStyles } from 'tss-react/mui'
import { createContext, FC, ReactNode, useMemo, useState } from 'react'
import { useReactiveVar } from '@apollo/client'
import clsx from 'clsx'
import { alertQueueVar } from '../../cache/alerts'
import { AlertContext } from '../../ts/interfaces/alertContext.interface'
import Alert from './components/Alert'

export const AlertMessengerContext = createContext<AlertContext>({} as AlertContext)

const useStyles = makeStyles()(() => ({
  alertWrapper: {
    zIndex: 1,
    height: 'auto',
    position: 'fixed',
    top: '10px',
    width: '100%',
    right: 0,
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}))

const AlertContextProvider: FC<{
  children: ReactNode
  autoHideTimeout?: number
}> = ({ children, autoHideTimeout = 5000 }) => {
  const alertQueue = useReactiveVar(alertQueueVar)
  const [pauseAutoHide, setPauseAutoHide] = useState(false)
  const { classes } = useStyles()

  const handleMouseOverPauseAutoHide = () => {
    setPauseAutoHide(true)
  }

  const handleMouseOverExitPauseAutoHide = () => {
    setPauseAutoHide(false)
  }

  const contextValue = useMemo(() => ({}), [])

  return (
    <AlertMessengerContext.Provider value={contextValue}>
      {children}

      <div className={clsx(classes.alertWrapper)}>
        {alertQueue?.map(
          ({ type, message, id, onClose, onOk, okButtonLabel, pauseAutoHideProp }: any) => (
            <div
              key={`alert__message__${id}`}
              data-testid="alert-message-container"
              onMouseOver={handleMouseOverPauseAutoHide}
              onMouseLeave={handleMouseOverExitPauseAutoHide}
              onFocus={handleMouseOverPauseAutoHide}
              onBlur={handleMouseOverExitPauseAutoHide}
              role="alert"
              aria-live="polite"
            >
              <Alert
                id={id}
                type={type}
                message={message}
                pauseAutoHideProp={pauseAutoHideProp}
                pauseAutoHide={pauseAutoHide}
                autoHideTimeout={autoHideTimeout}
                onClose={onClose}
                onOk={onOk}
                okButtonLabel={okButtonLabel}
              />
            </div>
          )
        )}
      </div>
    </AlertMessengerContext.Provider>
  )
}

export default AlertContextProvider
